<template>
  <b-card>
    <b-row>
      <b-col>
        <h3>{{ $route.name }}</h3>
        <b-breadcrumb>
          <b-breadcrumb-item
            ><router-link to="/dashboard/">{{$t('dashboard')}}</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item
            ><router-link to="/attendance/">{{$t('attendance')}}</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
        <div class="border-bottom mb-3"></div>
      </b-col>
    </b-row>
    <div v-if="isLoading">
      <div class="text-center" style="margin: 3% auto;">
          <b-spinner small type="grow" label="Small Spinner"></b-spinner>
          <b-spinner small variant="primary" type="grow" label="Small Spinner"></b-spinner>
          <b-spinner small variant="success" type="grow" label="Small Spinner"></b-spinner>
      </div>
    </div>
    <div v-else>
    <h5 v-if="getDate(today.clockInTime) === getDate(now)">{{$t('today_report')}}</h5>
    <h5 v-else>Report {{getDate(today.clockInTime)}}</h5>
    <b-row v-if="today.clockInTime !==null" class="mt-3 mb-2">
      <b-col lg="6">
        <b-row>
          <b-col md="3">
            <label class="labels">{{$t('name')}}</label>
          </b-col>
          <b-col md="3">
            <p v-text="today.userProfile !==null ? today.userProfile : '-'"></p>
          </b-col>
        </b-row>

        <!-- <b-row>
          <b-col md="3">
            <label class="labels">Date</label>
          </b-col>
          <b-col md="3">
            <p v-text="getDate(today.clockInTime)"></p>
          </b-col>
        </b-row> -->

        <b-row>
          <b-col md="3">
            <label class="labels">{{$t('outStation')}}</label>
          </b-col>
          <b-col md="3">
            <div v-if="today.isOutstation === true">
               <i class="fa fa-check" aria-hidden="true"></i>
            </div>
            <div v-else>
              <p>-</p>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="3">
            <label class="labels">{{$t('clockin')}}</label>
          </b-col>
          <b-col md="3">
            <p
              v-text="
                today.clockInTime !== null
                  ? new Date(today.clockInTime).toLocaleTimeString().replace('.', '.')
                  : '-'
              "
            ></p>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="3">
            <label class="labels">{{$t('clockout')}}</label>
          </b-col>
          <b-col md="3">
            <p
              v-text="
                today.clockOutTime !== null
                  ? new Date(today.clockOutTime).toLocaleTimeString().replace('.', '.')
                  : '-'
              "
            ></p>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="3">
            <label class="labels">{{$t('startBreak')}}</label>
          </b-col>
          <b-col md="3">
            <p
              v-text="
                today.breakInTime !== null
                  ? new Date(today.breakInTime).toLocaleTimeString().replace('.', '.')
                  : '-'
              "
            ></p>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="3">
            <label class="labels">{{$t('endBreak')}}</label>
          </b-col>
          <b-col md="3">
            <p
              v-text="
                today.breakOutTime !== null
                  ? new Date(today.breakOutTime).toLocaleTimeString().replace('.', '.')
                  : '-'
              "
            ></p>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3">
            <label class="labels">{{$t('totalLate')}}</label>
          </b-col>
          <b-col md="3">
            <p v-if="today.totalMinutesLate !== null && today.totalMinutesLate !==0">{{ today.totalMinutesLate !== null && today.totalMinutesLate !==0 ? today.totalMinutesLate : '-' }}{{' ' + $t('minutes')}}</p>
            <p v-else>-</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3">
            <label class="labels">{{$t('totalHour')}}</label>
          </b-col>
          <b-col md="3">
            <p>{{ today.clockHour !== null ? today.clockHour : '-' }}</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3">
            <label class="labels">{{$t('breakHour')}}</label>
          </b-col>
          <b-col md="3">
            <p>{{ today.breakHour !== null ? today.breakHour : '-' }}</p>
          </b-col>
        </b-row>

        <b-row class="mt-3 mb-2">
          <b-col md="3">
            <label class="labels pt-5 mt-5">{{$t('clockInPic')}}</label>
          </b-col>
          <b-col md="3">
            <viewer>
              <b-row>
                <b-col md="3">
                  <p
                    class="text-secondary text-center border p-5 d-flex"
                    v-if="today.clockInPicture === null"
                  >
                    <i>No Photo Submitted</i>
                  </p>
                  <b-img
                    :src="today.clockInPicture"
                    class="img-responsive "
                    v-b-tooltip.focus
                    title="Click to view image"
                    width="300"
                    height="200"
                  />
                </b-col>
              </b-row>
            </viewer>
          </b-col>
        </b-row>

        <b-row class="mt-3 mb-2">
          <b-col md="3">
            <label class="labels pt-5 mt-5">{{$t('clockOutPic')}}</label>
          </b-col>
          <b-col md="3">
            <viewer>
              <b-row>
                <b-col md="3">
                  <p
                    class="text-secondary text-center border p-5 d-flex"
                    v-if="today.clockOutPicture == null"
                  >
                    <i>No Photo Submitted</i>
                  </p>
                  <b-img
                    v-else
                    :src="today.clockOutPicture"
                    v-b-tooltip.focus
                    class="img-responsive"
                    width="300"
                    height="200"
                  />
                </b-col>
              </b-row>
            </viewer>
          </b-col>
        </b-row>
      </b-col>

      <b-col lg="6">
            <b-tabs pills card content-class="mt-1 h-auto"> 
              <b-tab pills :title="$t('clockInLoc')" active style="height: 700px">
                <label class="labels">{{$t('clockInLoc')}}</label>
                <GmapMap v-if="today.clockInLatitude !==0"
                  :center="today.positionIn"
                  :zoom="17"
                  map-type-id="terrain"
                  style="width: 100%; height: 70%"
                >
                  <GmapMarker
                    :position="today.positionIn"
                    :clickable="true"
                    :draggable="true"
                    @click="center = today.positionIn"
                  />
                </GmapMap>
                <div v-else>
                  <h6 class="text-center text-secondary">No Location Found!</h6>
                </div>
              </b-tab>
              <b-tab pills card :title="$t('clockOutLoc')" style="height: 700px">
                <label class="labels">{{$t('clockOutLoc')}}</label>
                <GmapMap v-if="today.clockOutLatitude !==0"
                  :center="today.positionOut"
                  :zoom="17"
                  map-type-id="terrain"
                  style="width: 100%; height: 70%"
                >
                  <GmapMarker
                    :position="today.positionOut"
                    :clickable="true"
                    :draggable="true"
                    @click="center = today.positionOut"
                  />
                </GmapMap>
                <div v-else>
                  <h6 class="text-center text-secondary">No Location Found!</h6>
                </div>
              </b-tab>
            </b-tabs>
            
          </b-col>


      <b-col lg="6"> </b-col>
    </b-row>
    <b-row v-else>
      <b-col md="12">
        <div class="m-auto justify-content-center text-center h-75">
        <h1 style="font-size: 86px; opacity: 0.3;" class="text-center text-uppercase font-weight-bolder text-info text-bold">{{$t('noReport')}}</h1>
        <h4 style="opacity: 0.2;">{{$t('noFilled')}}</h4>
        </div>
      </b-col>
    </b-row>


    <b-row class="mt-5 mb-3">
      <b-col>
        <div class="d-flex align-items-center">
          <h5>{{$t('histories')}}</h5>
          <b-link class="ml-4 mb-1" :href="'#/attendance/' + today.userProfileUuid + '/all'">Lihat semua riwayat</b-link>
        </div>
        <b-row>
          <b-col md="12">
            <div class="table-responsive">
              <table class="table table-hovered table-striped">
                <thead>
                  <tr>
                    <th scope="col" width="100">{{$t('name')}}</th>
                    <th scope="col" width="100">{{$t('outStation')}}</th>
                    <th scope="col" width="100">{{$t('clockin')}}</th>
                    <th scope="col" width="100">{{$t('leave')}}</th>
                    <th scope="col" width="100">{{$t('startBreak')}}</th>
                    <th scope="col" width="100">{{$t('endBreak')}}</th>
                    <th scope="col" width="100">{{$t('clockout')}}</th>
                    <th scope="col" width="100">{{$t('totalLate')}}</th>
                    <th scope="col" width="100">{{$t('totalHour')}}</th>
                    <!-- <th scope="col" width="100">Overtime</th> -->
                    <th scope="col" width="100">{{$t('detail')}}</th>
                  </tr>
                </thead>
                <tbody v-if="dataUser.length > 0">
                  <tr v-for="(item, index) in dataUser" :key="index">
                    <td v-text="getDate(item.clockInTime)"></td>
                    <td>
                      <div v-if="item.isOutstation === true">
                        <i class="fa fa-check" aria-hidden="true"></i>
                      </div>
                      <div v-else>
                        <p>-</p>
                      </div>
                    </td>
                    <td
                      v-text="
                        item.clockInTime !== null
                          ? new Date(item.clockInTime).toLocaleTimeString().replace('.', '.')
                          : '-'
                      "
                    ></td>

                     <td
                      v-text="
                        item.leave
                          ? item.leave
                          : '-'
                      "
                    ></td>

                    <td
                      v-text="
                        item.breakInTime !== null
                          ? new Date(item.breakInTime).toLocaleTimeString().replace('.', '.')
                          : '-'
                      "
                    ></td>
                    <td
                      v-text="
                        item.breakOutTime !== null
                          ? new Date(item.breakOutTime).toLocaleTimeString().replace('.', '.')
                          : '-'
                      "
                    ></td>
                    
                    <td
                      v-text="
                        item.clockOutTime !== null
                          ? new Date(item.clockOutTime).toLocaleTimeString().replace('.', '.')
                          : '-'
                      "
                    ></td>
                    <td>
                      <p v-if="item.totalMinutesLate !==null && item.totalMinutesLate !==0">
                      {{ item.totalMinutesLate !==null && item.totalMinutesLate !==0 ? item.totalMinutesLate : '-' }} {{' ' + $t('minutes')}}
                      </p>
                      <p v-else>-</p>
                    </td>
                    <td>{{ item.clockHour }}</td>
                    <td>
                      <a
                        v-if="canShowRoutePath"
                        v-b-tooltip.hover.left
                        :title="$t('detail')"
                        class="btn-op icon-info mr-1"
                        :href="'/#/attendance' + '/' + item.uuid + '/' + 'history'"
                      ></a>
                      <a
                        v-else
                        v-b-tooltip.hover.left
                        :title="$t('detail')"
                        class="btn-op icon-info mr-1"
                        :href="'#' + $route.path + '/' + item.uuid"
                      ></a>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td></td>
                    <td></td>
                    <td><i>no data found </i></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>


          </b-col>
        </b-row>
      </b-col>
    </b-row>
    </div>
          <!-- <paginated-table ref="dataTable" :can-show="true" :can-delete="false" :can-edit="false" :can-approve="false" :data-url="apiUrl.attendance" :can-reject="false" :data-key="dataKey" :data-columns="columns" :data-params="['company_uuid', 'branch_uuid', 'type', 'name', 'customer_id']">
          </paginated-table> -->
    <b-button class="mt-3 mb-5" @click="goBack" variant="secondary"
      ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
    >
  </b-card>
</template>

<script>
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
import Vue from 'vue';
// import PaginatedTable from '../../components/PaginatedTable.vue';
Vue.use(Viewer);

export default {
  // components: { PaginatedTable },
  data() {
    return {
      isLoading: false,
      now: new Date(),
      src: '',
      dataKey: 'attendance',
      dataHistory: false,
      today: {
        clockInTime: null,
        clockInLatitude: 0,
        clockInLongitude: 0,
        clockInPicture: null,
        clockInNote: null,
        clockOutTime: null,
        clockOutLatitude: 0,
        clockOutLongitude: 0,
        clockOutPicture: null,
        clockOutNote: '',
        clockHour: null,
        clockTimeDiff: null,
        breakInTime: null,
        breakInLatitude: 0,
        breakInLongitude: 0,
        breakInPicture: null,
        breakInNote: null,
        breakOutTime: null,
        breakOutLatitude: 0,
        breakOutLongitude: 0,
        breakOutPicture: null,
        totalMinutesLate: null,
        breakOutNote: null,
        breakHour: null,
        breakTimeDiff: null,
        isOutstation: null,
        createdAt: '',
        updatedAt: '',
        uuid: '',
        account: '',
        userProfile: null,
        userProfileUuid: null,
        uuidHistory: '',
        position: {
          lat: 0,
          lng: 0,
        },
        positionIn: { lat: 0, lng: 0 },
        positionOut :{lat : 0, lng: 0},
        // positionBreakOut: { lat: null, lng: null },
      },
      dataUser: [],
      items: [],
      images: '',
      canShowRoutePath: {
        type: String,
        required: false,
        default: '',
      },
      // dataKey: '',
      columns: [
        {
          key: 'clockInTime',
          label: 'Date'
        }
      ],
      apiUrl: {
        attendance: window.AppConfig.apiUrl + 'attendance',
        attendanceReport: window.AppConfig.apiUrl + 'attendance-report',
      },
    };
  },

  mounted() {
    // this.getUserHistory();
    this.getDate();
    this.getClockTime();
    this.getDetails();
  },

  methods: {
    /**
     * function getUserHistory tidak dipakai
     * sayang kalo mau dihapus hehheeh
     */
    async getUserHistory() {
      const { data } = await this.$http.get(
        this.apiUrl.attendance + '/' + this.today.account
      );
      this.items = data._embedded.attendance;
      this.today = data._embedded.attendance[0];
      this.dateTimeNow = data._embedded.attendance[0].clockInTime;
      if (this.getDate(this.dateTimeNow) === this.getDate(new Date)) {
        this.dataHistory = true
        console.log('clock in hari ini', this.dateTimeNow);
        console.log(this.getDate(new Date));
      } else {
        console.log('hari ini belum clock in', this.getDate(new Date));
      }
      console.log('ini data user ketika clock in tanggal :', this.getDate((this.dateTimeNow)));

      const d = data._embedded.attendance;
      (this.today.positionIn = {
        lat: d[0].clockInLatitude,
        lng: d[0].clockInLongitude,
      }),
        (this.today.positionOut = {
          lat: d[0].clockOutLatitude,
          lng: d[0].clockOutLongitude,
        }),
        (this.today.positionBreakIn = {
          lat: d[0].breakInLatitude,
          lng: d[0].breakInLongitude,
        }),
        (this.today.positionBreakOut = {
          lat: d[0].breakOutLatitude,
          lng: d[0].breakOutLongitude,
        });
    },

    
    getDetails() {
      this.isLoading = true
      this.$http.get(this.apiUrl.attendance + '/' + this.$route.params.uuid).then((resp) => {
        this.today.breakInTime = resp.data.breakInTime
        this.today.breakInLatitude = resp.data.breakInLatitude
        this.today.breakInLongitude = resp.data.breakInLongitude
        this.today.breakInPicture = resp.data.breakInPicture
        this.today.breakInNote = resp.data.breakInNote
        this.today.breakOutTime = resp.data.breakOutTime
        this.today.breakOutLatitude = resp.data.breakOutLatitude
        this.today.breakOutLongitude = resp.data.breakOutLongitude
        this.today.breakOutPicture = resp.data.breakOutPicture
        this.today.breakOutNote = resp.data.breakOutNote
        this.today.breakHour = resp.data.breakHour
        this.today.clockInTime = resp.data.clockInTime
        this.today.clockInLongitude = resp.data.clockInLongitude
        this.today.clockInLatitude = resp.data.clockInLatitude
        this.today.clockInPicture = resp.data.clockInPicture
        this.today.clockInNote = resp.data.clockInNote
        this.today.clockOutTime = resp.data.clockOutTime
        this.today.clockOutLongitude = resp.data.clockOutLongitude
        this.today.clockOutLatitude = resp.data.clockOutLatitude
        this.today.clockOutPicture = resp.data.clockOutPicture
        this.today.leave = resp.data.leave
        this.today.clockOutNote = resp.data.clockOutNote
        this.today.userProfile = resp.data.userProfile 
        this.today.userProfileUuid = resp.data.userProfileUuid 
        this.today.totalMinutesLate = resp.data.totalMinutesLate
        this.today.isOutstation = resp.data.isOutstation
        this.today.uuid = resp.data.uuid
        this.today.account = resp.data.account
        if(resp.data.clockInTime !== null){
          this.$http.get(this.apiUrl.attendance + '?user_uuid=' + this.today.userProfileUuid).then(resp=>{
            this.dataUser = []
            this.dataUser = resp.data._embedded.attendance
          })
        } else {
          console.log('hahahahah');
        }

        if(this.today.clockInLatitude !==0 && this.today.clockInLongitude !==0){
          this.today.positionIn = {
            lat: this.today.clockInLatitude,
            lng: this.today.clockInLongitude
          }
        }

         if(this.today.clockOutLatitude !==0 && this.today.clockOutLongitude !==0){
          this.today.positionOut = {
            lat: this.today.clockOutLatitude,
            lng: this.today.clockOutLongitude
          }
        }
        setTimeout(()=>{
          this.isLoading = false
        }, 1000)
        // resp.data._embedded.attendance.forEach(data => {
        //   this.dataHistory.push({
        //     value: data.uuid,
        //     text: data.name
        //   })
        // });

      }).catch(() => {
        setTimeout(()=>{
          this.getDetails()
        this.isLoading = false
        },1000)
      })
    },

    // async getDetailUserHistory() {
    //   const {data} = await this.$http.get(this.apiUrl.attendanceReport + '?start_date=' + this.$route.params.uuid);
    //   console.log(data);

    // },

    getClockTime(value) {
      if (value !== null) {
        return this.$moment(value).format('HH:mm');
      } else {
        return '-';
      }
    },

    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('H:mm DD MMMM YYYY');
      } else {
        return '-';
      }
    },

    getDate(value) {
      if (value !== null) {
        return this.$moment(value).format('YYYY-MM-DD');
      } else {
        return '-';
      }
    },

    goBack() {
      window.goBack(this);
    },
  },
};
</script>
<style scoped>
.fa-check{
  color:#fff;
  font-size: 22px;
  background-color: rgb(5, 151, 5);
  width: 36px;
  border-radius: 6px;
  text-align: center;
}
</style>
